import { getValue } from "@utils/lodash";
import { NavLink } from "react-router-dom";
// import "./inner-page-navigation.scss";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { useNavigate } from "react-router-dom";
import RightMenuHeaders from "@components/common/RightMenuHeaders";

export default function VendorComplianceTaskNavigation(props: any) {
  const urlParamsFun = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let request = QueryRequestHelper({ ...params });
    return request;
  };

  const mainQueryRequest = urlParamsFun();
  const navigate = useNavigate();
  const handleNavigate = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
    };
    let queryRequest = QueryRequestHelper(payload);
    if (getValue(params, `redirect_url`, "")) {
      navigate(`${getValue(params, `redirect_url`, "")}?${mainQueryRequest}`);
    } else {
      navigate(
        `/${getValue(props, `global_route`, "")}/${getValue(
          props,
          `parent_route`,
          ""
        )}/${getValue(props, `main_route`, "")}?${queryRequest}`
      );
    }
  };
  const handleNavigateTab = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
    };
    let queryRequest = QueryRequestHelper(payload);
    return queryRequest;
  };
  return (
    <>
      <div className="task-license-subheader">
        <div className="inner-page-navigation-with-back-cta-buttons position-relative">
          <div className="container-fluid  d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              {/* <NavLink
								to={`/${getValue(props, `parent_route`, "")}/${getValue(
									props,
									`main_route`,
									""
								)}`}
								className=""
							> */}
              <div onClick={handleNavigate}>
                <img
                  src="/images/back-link.svg"
                  className="img-fluid"
                  height={24}
                  width={24}
                />
              </div>
              {/* </NavLink> */}

              <div className="inner-page-navigation-with-back-cta-button__header">
                <h4 className="inner-page-navigation-with-back-cta-button__header-title"></h4>
              </div>
              <ul className="inner-page-navigation-with-back-cta-buttons__navigation d-inline-flex position-absolute ">
                {props.id && props.id !== "undefined" && (
                  <>
                    <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                      <NavLink
                        to={`/${getValue(props, `global_route`, "")}/${getValue(
                          props,
                          `parent_route`,
                          ""
                        )}/${getValue(props, `main_route`, "")}/task-details/${
                          props.id
                        }/${props.checkpoint_id}?${mainQueryRequest}`}
                        className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                      >
                        Task Details
                      </NavLink>
                    </li>
                    <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                      <NavLink
                        to={`/${getValue(props, `global_route`, "")}/${getValue(
                          props,
                          `parent_route`,
                          ""
                        )}/${getValue(props, `main_route`, "")}/task-history/${
                          props.id
                        }/${props.checkpoint_id}?${mainQueryRequest}`}
                        className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                      >
                        Task History
                      </NavLink>
                    </li>
                    {/* <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                        <NavLink
                          to={`/${getValue(props, `parent_route`, "")}/${getValue(
                            props,
                            `main_route`,
                            ""
                          )}/sub-task/${props.id}/${props.checkpoint_id}`}
                          className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                        >
                          Sub-Tasks
                        </NavLink>
                      </li> */}
                  </>
                )}
              </ul>
            </div>

            <div className="d-flex align-items-center d-none">
              {getValue(props, `permissions`, []).includes("update") ? (
                <div className="d-flex align-items-center">
                  {props.save ? (
                    props.submitLoading ? (
                      <button className="ascent-button  ascent-button--header-buttons ascent-button--primary">
                        Please wait...
                      </button>
                    ) : (
                      <button
                        className={`ascent-button  ascent-button--header-buttons ascent-button--${
                          !props.isChanged ? "secondary" : "primary"
                        }`}
                        onClick={props.handleSubmit}
                        // disabled={props.isChanged}
                      >
                        Save
                      </button>
                    )
                  ) : (
                    <button className="ascent-button ascent-button--visibility ascent-button--header-buttons ascent-button--primary">
                      Save
                    </button>
                  )}
                  {props.showTaskInfo && (
                    <button
                      className={`ascent-button  ascent-button--header-buttons ascent-button--secondary m-0`}
                      onClick={props.handleClickPopup}
                      // disabled={props.isChanged}
                    >
                      {getValue(props, `main_route`, "") ===
                        "pending-approval" ||
                      getValue(props, `main_route`, "") === "my-task" ||
                      getValue(props, `main_route`, "") === "master" ||
                      getValue(props, `main_route`, "") === "function-head" ||
                      getValue(props, `main_route`, "") === "evaluator" ||
                      getValue(props, `main_route`, "") === "pending-audit" ||
                      getValue(props, `main_route`, "") === "completed-audit"
                        ? "Update Task"
                        : "Task Info"}
                    </button>
                  )}
                </div>
              ) : (
                <button className="ascent-button ascent-button--visibility ascent-button--header-buttons ascent-button--primary">
                  Save
                </button>
              )}

              {getValue(props, `isTaskHistorySearch`, false) && (
                <>
                  <RightMenuHeaders
                    //search
                    isSearch={true}
                    searchInput={props.searchInput}
                    showSearchTextbox={props.showSearchTextbox}
                    toggleSearch={props.toggleSearch}
                    toggleSearchClose={props.toggleSearchClose}
                    handleChangeSearch={props.handleChangeSearch}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
